import moment from "moment";
import Toast from 'light-toast';
import ShowToast from 'components/ShowToast';
import { TYPE_SUCCESS,TYPE_FAIL, INTERVAL, TYPE_INFO } from "assets/constants/Constants";
import { getMetaDataCall, createBulkCandidate, sendDropoutEmail } from "lib/axiosUtils";
import { downloadDocumentBucket } from 'lib/axiosUtils';

export const onSortColumn = (dataArray, column, orderFlag) => {
    let sortedData = [];
    if (orderFlag === "asc") {
        sortedData = dataArray.sort((a, b) => {
            if (a[column] < b[column]) return -1;
            if (a[column] > b[column]) return 1;
            if (a[column] === b[column]) return 1;
            return 1;
        });
    } else {
        sortedData = dataArray.sort((a, b) => {
            if (a[column] > b[column]) return -1;
            if (a[column] < b[column]) return 1;
            if (a[column] === b[column]) return 1;
            return 1;
        });
    }
    return sortedData;
}

export const defaultFormatDate = (item) => {
    let formatedDate = null;
    formatedDate = moment(item).format("DD-MM-YYYY"); 
    return formatedDate;
}

export const showLoading = (message = "Please wait...") => {
    Toast.loading(message, () => {});
}

export const hideLoading = () => {
    Toast.hide();
}

export const registerBulkCandidate = async (requestData) => {
    let importData = [];
    const userDetail = JSON.parse(localStorage.getItem("userData"));
    if (requestData && requestData.length > 0) {
        try {
            const dataResponse = await createBulkCandidate({}, {...requestData, userId: userDetail._id});
            importData = dataResponse.data.result;
            ShowToast("Candidate Imported successfully", TYPE_SUCCESS, INTERVAL, "", "");
            return importData;
        }
        catch (error) {
            console.log("Error Occurred while registring bulk candidate through excel import", error);
            ShowToast("Something went wrong. Please try importing again after sometime!", TYPE_FAIL, INTERVAL, "", "");
            return importData;
        }
    }
    else{
        ShowToast("No Candidate in Excel for Importing", TYPE_INFO, INTERVAL, "", "");
        return importData;
    }
}

export const validateCandidateData = (requestData) => {
    let validateFlag = true;
    requestData.forEach((candidateItem) => {
        if (validateFlag === true && candidateItem.validCandidate === false) {
            validateFlag = false;
        }
    })
    return validateFlag;
}

export const fetchMetadata = async () => {
    try {
        const getMetaData = await getMetaDataCall({},{});
        localStorage.setItem("metadata", JSON.stringify(getMetaData.data.result));
        return getMetaData.data.result;
    }
    catch (error) {
        console.log("Error Occurred while fetching metadata", error);
    }
}

export const toCapitaliseWord = (string) => {
    return string.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
};

export const sendDroppedEmailCandidate = async (droppedData) => {
    try {
        if (droppedData.email) {
            const emailData = {
                candidateEmailId: droppedData.email,
                firstName: droppedData.first_name,
                lastName: droppedData.last_name,
                adhaarNo: droppedData.adhaar_no,
                programId: droppedData.programId
            }
            await sendDropoutEmail({}, emailData);
        }
    } catch (error) {
        console.log("Error while sending dropped candidate email", error);
    }
}

export const validateEmployerData = (requestData) => {
    let validateFlag = true;
    requestData.forEach((employerItem) => {
        if (validateFlag === true && employerItem.validEmployer === false) {
            validateFlag = false;
        }
    })
    return validateFlag;
}

export const validatePartnerData = (requestData) => {
    let validateFlag = true;
    requestData.forEach((partnerItem) => {
        if (validateFlag === true && partnerItem.validPartner === false) {
            validateFlag = false;
        }
    })
    return validateFlag;
}

export const generateFinanceYearOptions = () => {
    const currentYear = new Date().getFullYear();
    return [
        { label: "All Years", value: "all" },
        { label: `${currentYear} - ${currentYear + 1}`, value: `${currentYear}-${currentYear + 1}` },
        { label: `${currentYear - 1} - ${currentYear}`, value: `${currentYear - 1}-${currentYear}` },
        { label: `${currentYear - 2} - ${currentYear - 1}`, value: `${currentYear - 2}-${currentYear - 1}` }
    ]
}

export const detectDateFormat = (stringDate) => {
    const possibleFormats = [
        'YYYY-MM-DD',
        'DD/MM/YYYY',
        'DD-MM-YYYY',
        'DD.MM.YYYY',
        'MM/DD/YYYY',
        'MMM DD YYYY',
        'DD MMM YYYY',
        'Do MMM YYYY',
        'DD/MM/YY',
        'DD-MM-YY',
        'DD.MM.YY',
        'DD MMM YY',
    ];

    let detectedFormat = null;
    let detectedFlag = false;
    possibleFormats.forEach(format => {
        if (moment(stringDate, format, true).isValid()) {
            if (detectedFlag === false) {
                detectedFormat = format;
                detectedFlag = true;
            }
        }
    });
    return detectedFormat;
}

export const decimalToTime = (decimalTime) => {
    const totalSeconds = decimalTime * 24 * 60 * 60;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const formattedHours = hours % 12 || 12; // Handle 0 hours as 12 AM
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const ampm = hours < 12 ? 'AM' : 'PM';
    const formattedTime = formattedHours + ':' + formattedMinutes + ' ' + ampm;
    return formattedTime;
}

export const calculateAgeFromDate = (birthDate) => {
    if (!birthDate) {
        return "";
    }

    let parsedBirthDate = birthDate;
    if (typeof birthDate === "string" && birthDate.includes("/")) {
        parsedBirthDate = birthDate.split('/').reverse().join('-');
    }

    const dob = new Date(parsedBirthDate);
    if (Number.isNaN(dob.getTime())) {
        return "";
    }

    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDifference = today.getMonth() - dob.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dob.getDate())) {
        age -= 1;
    }

    return age;
}

export const getAge = birthDate => calculateAgeFromDate(birthDate);

export const convertDateInCorrectFormat = (date) => {
    const selectedDate = new Date(date);
    const returnDate = new Date(Date.UTC(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate()
    ));
    return returnDate;
}

// Same logic as FileDownloadWidget
const getS3Key = (url) => {
    if (!url) return null;
    const s3UrlPattern = /^https:\/\/([^/]+)\.s3\.amazonaws\.com\/(.+)$/;
    const match = url.match(s3UrlPattern);
    return match?.[2] || url;
};

// Get pre-signed URL -> fetch image -> return base64
export const fetchImageAsBase64FromS3 = async (s3Url) => {
    try {
        const s3Key = getS3Key(s3Url);
        if (!s3Key) return null;

        // Step 1: Get pre-signed download URL from your backend (same as FileDownloadWidget)
        const response = await downloadDocumentBucket({}, { fileKey: s3Key });
        if (!response.data?.downloadUrl) return null;

        const downloadUrl = response.data.downloadUrl;

        // Step 2: Fetch the actual image bytes using the pre-signed URL
        const imageResponse = await fetch(downloadUrl);
        if (!imageResponse.ok) return null;

        const blob = await imageResponse.blob();

        // Step 3: Convert to base64 for ExcelJS
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result.split(',')[1]); // raw base64 only
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (err) {
        console.warn('Photo fetch failed for Excel:', err);
        return null;
    }
};

export const sanitizeAnnualIncome = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }

    if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
    }

    const rawValue = String(value).trim();
    if (!rawValue) {
        return null;
    }

    const normalizedValue = rawValue
        .replace(/[₹$A-Za-z]/gi, " ")
        .replace(/,/g, "")
        .replace(/[\s/]/g, "")
        .replace(/[^\d.-]/g, "");

    const match = normalizedValue.match(/-?\d+(?:\.\d+)?/);
    if (!match) {
        return null;
    }

    const parsedValue = Number(match[0]);
    return Number.isFinite(parsedValue) ? parsedValue : null;
};